import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

type Props = {
    content: string;
    minHeight?: number;
};

const ReleaseNoteContent: FC<Props> = ({ content, minHeight }) => {
    const { t: translate } = useTranslation('release-notes');

    if (!content) {
        return (
            <Typography color="text.secondary" variant="body2" sx={{ mt: 1 }}>
                {translate('EDITOR_PLACEHOLDER_MAIN')}
            </Typography>
        );
    }

    return (
        <Box
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
            sx={{
                minHeight,
                '& h1': { fontSize: '1.5rem', fontWeight: 700, mt: 2, mb: 1 },
                '& h2': { fontSize: '1.25rem', fontWeight: 600, mt: 2, mb: 0.75 },
                '& h3': { fontSize: '1.1rem', fontWeight: 600, mt: 1.5, mb: 0.5 },
                '& p': { mt: 0, mb: 1.25, lineHeight: 1.7 },
                '& ul, & ol': { pl: 3, mb: 1 },
                '& li': { mb: 0.5 },
                '& strong': { fontWeight: 600 },
            }}
        />
    );
};

export default ReleaseNoteContent;
